import React, { createContext, useContext, useEffect, useState } from "react";
import { api } from "./api";

const AuthContext = createContext(null);
const TOKEN_KEY = "fs_token";

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);  // { id, name, email|mobile, role, ... }
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem(TOKEN_KEY) || localStorage.getItem("fs_admin_token");
    if (!token) {
      setLoading(false);
      return;
    }
    // Backward compat: migrate old key
    if (!localStorage.getItem(TOKEN_KEY) && localStorage.getItem("fs_admin_token")) {
      localStorage.setItem(TOKEN_KEY, localStorage.getItem("fs_admin_token"));
    }
    api.get("/auth/me")
      .then((r) => setUser(r.data))
      .catch(() => { localStorage.removeItem(TOKEN_KEY); localStorage.removeItem("fs_admin_token"); })
      .finally(() => setLoading(false));
  }, []);

  const login = async (identifier, password) => {
    const { data } = await api.post("/auth/login", { identifier, password });
    localStorage.setItem(TOKEN_KEY, data.token);
    localStorage.setItem("fs_admin_token", data.token); // legacy compat for older interceptor
    setUser({ ...data.user, role: data.role });
    return data;
  };

  const logout = () => {
    localStorage.removeItem(TOKEN_KEY);
    localStorage.removeItem("fs_admin_token");
    setUser(null);
  };

  // Convenience flags
  const role = user?.role;
  const isAdmin = role === "super_admin" || role === "operator";
  const isSuperAdmin = role === "super_admin";
  const isLeadOrCustomer = role === "lead" || role === "customer";

  return (
    <AuthContext.Provider value={{ user, admin: user, role, loading, login, logout, isAdmin, isSuperAdmin, isLeadOrCustomer }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
